// ========================================
// Main Entry Point - Common Scripts
// 全ページ共通のJavaScript
// ========================================

// ---------------------------
// _load-common.js (inlined)
// Header and Footer Loader (jQuery版)
// ヘッダーとフッターを動的に読み込むスクリプト
// ---------------------------
(function($) {
  'use strict';

  // ベースパスを取得
  // data-base-path属性から取得、なければ空文字
  const basePath = $('script[data-base-path]').data('base-path') || '';
  
  // 相対パスでの読み込みも考慮
  // ページのURLから自動的に適切なパスを生成
  function getCommonPath() {
    if (basePath) {
      return basePath;
    }
    // basePathが設定されていない場合は、現在のページのパスから判断
    const path = window.location.pathname;
    if (path.includes('/sismil/')) {
      return '/sismil';
    }
    return '';
  }
  
  const commonBasePath = getCommonPath();
  
  /**
   * ヘッダーの初期化処理
   */
  function initHeader() {
    // トップページの場合、l-header--topクラスを追加
    // ただし、/inquiry/ 以下は除外
    const currentPath = window.location.pathname;
    const isInquiryPage = currentPath.includes('/inquiry/');
    const isTopPage = !isInquiryPage && (
      currentPath === '/' || 
      currentPath === '/sismil/' || 
      currentPath === '/sismil/index.html' ||
      currentPath.endsWith('/sismil/') ||
      currentPath.endsWith('/sismil/index.html')
    );
    
    if (isTopPage) {
      $('.l-header').addClass('l-header--top');
      console.log('Top page detected: l-header--top class added');
    }
    
    // メガメニューのドロップダウン
    $('.l-header__nav-item--dropdown').on('click', function(e) {
      // リンクのデフォルト動作を一時的に防ぐ
      // if ($(e.target).closest('.l-header__nav-link').length) {
      //   e.preventDefault();
      // }
      
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
      } else {
        // 他のメニューを閉じる
        $('.l-header__nav-item--dropdown').removeClass('active');
        $(this).addClass('active');
      }
    });

    /**
     * モバイルメニューを閉じる処理
     */
    function closeMobileMenu() {
      $('.l-header__menu-button')
        .attr('aria-expanded', 'false')
        .removeClass('active');
      $('.l-header__mobile-menu').removeClass('active');
      $('.l-header').removeClass('menu-open');
      $('body').removeClass('menu-open');
    }

    // SPメニューボタン
    $('.l-header__menu-button').on('click', function() {
      const isActive = $(this).hasClass('active');
      
      if (isActive) {
        // メニューを閉じる
        closeMobileMenu();
      } else {
        // メニューを開く
        $(this).attr('aria-expanded', 'true');
        $(this).addClass('active');
        $('.l-header__mobile-menu').addClass('active');
        $('.l-header').addClass('menu-open');
        $('body').addClass('menu-open');
      }
    });

    // モバイルメニュー内のリンクをクリックしたらメニューを閉じる
    $('.l-header__mobile-menu a').on('click', function() {
      closeMobileMenu();
    });

    // ウィンドウリサイズ時の処理
    let resizeTimer;
    $(window).on('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        // PC幅（1200px以上）になったらモバイルメニューを閉じてスクロールを有効化
        if ($(window).width() >= 1200) {
          closeMobileMenu();
        }
      }, 250); // デバウンス: 250ms
    });

    // モバイルドロップダウン
    $('.l-header__mobile-dropdown-trigger').on('click', function() {
      const isExpanded = $(this).attr('aria-expanded') === 'true';
      
      $(this).attr('aria-expanded', !isExpanded);
      $(this).closest('.l-header__mobile-dropdown').toggleClass('active');
    });

    // 電話アイコンのツールチップ
    $('.l-header__icon-button--phone').on('click', function(e) {
      e.stopPropagation();
      const isExpanded = $(this).attr('aria-expanded') === 'true';
      $(this).attr('aria-expanded', !isExpanded);
      $(this).toggleClass('active');
    });
    
    // ツールチップ外をクリックしたら閉じる
    $(document).on('click', function() {
      $('.l-header__icon-button--phone')
        .attr('aria-expanded', 'false')
        .removeClass('active');
    });
  }

  /**
   * フッターの初期化処理
   */
  function initFooter() {
    // フッターのアコーディオン（モバイル）
    $('.l-footer__category-heading').on('click', function() {
      $(this).closest('.l-footer__category').toggleClass('active');
    });
  }

  /**
   * DOMContentLoaded時の処理
   */
  $(document).ready(function() {
    // デバッグ: パス情報を確認
    console.log('data-base-path attribute:', basePath);
    console.log('Computed Base Path:', commonBasePath);
    console.log('Header Path:', `${commonBasePath}/common/header.html`);
    console.log('Footer Path:', `${commonBasePath}/common/footer.html`);
    
    // ヘッダーを読み込み
    $('#header-placeholder').load(`${commonBasePath}/common/header.html`, function(response, status, xhr) {
      if (status === 'success') {
        console.log('Header loaded successfully');
        initHeader();
      } else {
        console.error('Failed to load header:', status, xhr.statusText);
        console.error('Attempted path:', `${commonBasePath}/common/header.html`);
      }
    });
    
    // フッターを読み込み
    $('#footer-placeholder').load(`${commonBasePath}/common/footer.html`, function(response, status, xhr) {
      if (status === 'success') {
        console.log('Footer loaded successfully');
        initFooter();
      } else {
        console.error('Failed to load footer:', status, xhr.statusText);
        console.error('Attempted path:', `${commonBasePath}/common/footer.html`);
      }
    });
  });
})(jQuery);

// ---------------------------
// _page-top.js (inlined)
// Page Top Button - ページトップへ戻るボタンの制御
// ---------------------------
$(function() {
  const $pageTopButton = $('#pageTopButton');

  if ($pageTopButton.length === 0) {
    console.log('Page top button not found');
    return;
  }

  // スクロール閾値（この値を超えたらボタンを表示）
  const SCROLL_THRESHOLD = 300;

  /**
   * スクロール位置に応じてボタンの表示/非表示を切り替え
   */
  function toggleButtonVisibility() {
    const scrollTop = $(window).scrollTop();

    if (scrollTop > SCROLL_THRESHOLD) {
      $pageTopButton.addClass('is-visible');
    } else {
      $pageTopButton.removeClass('is-visible');
    }
  }

  /**
   * ページトップへスムーズスクロール
   */
  function scrollToTop() {
    $('html, body').animate({
      scrollTop: 0
    }, 400);
  }

  // イベントリスナーの設定

  // スクロールイベント（パフォーマンス向上のため throttle を使用）
  let scrollTimer = null;
  $(window).on('scroll', function() {
    if (scrollTimer !== null) {
      clearTimeout(scrollTimer);
    }
    scrollTimer = setTimeout(function() {
      toggleButtonVisibility();
    }, 100);
  });

  // ボタンクリックイベント
  $pageTopButton.on('click', scrollToTop);

  // 初期状態を設定
  toggleButtonVisibility();

  console.log('Page top button initialized');
});

// ---------------------------
// Smooth Scroll - スムーススクロール機能
// ページ内アンカーリンクと別ページからのアンカーリンクに対応
// ---------------------------
$(function() {
  /**
   * スムーススクロールの実行
   * @param {string} targetId - スクロール先の要素ID（#なし）
   * @param {number} duration - アニメーション時間（ミリ秒）
   * @param {boolean} withCorrection - スクロール後に位置補正を行うか
   */
  function smoothScrollTo(targetId, duration = 600, withCorrection = false) {
    const $target = $('#' + targetId);
    
    if ($target.length === 0) {
      console.warn('Smooth scroll target not found:', targetId);
      return;
    }

    // ヘッダーの高さを取得（固定ヘッダーの場合のオフセット）
    const headerHeight = $('.l-header').outerHeight() || 0;
    const offset = 0; // 追加のオフセット（余白）
    
    const targetPosition = $target.offset().top - headerHeight - offset;

    $('html, body').animate({
      scrollTop: targetPosition
    }, duration, 'swing', function() {
      // スクロール完了後のコールバック
      if (withCorrection) {
        // 画像などの遅延読み込みによる位置ズレを補正
        setTimeout(function() {
          const newTargetPosition = $target.offset().top - headerHeight - offset;
          const currentPosition = $(window).scrollTop();
          
          // 位置が5px以上ズレている場合のみ補正
          if (Math.abs(currentPosition - newTargetPosition) > 5) {
            $('html, body').animate({
              scrollTop: newTargetPosition
            }, 200, 'swing');
          }
        }, 100);
      }
    });
  }

  /**
   * ページ内アンカーリンクのスムーススクロール
   * 同一ページ内のアンカーリンク、および他ページから来た後の同ページアンカーリンクに対応
   * イベント委譲を使用して、動的に読み込まれたヘッダー・フッター内のリンクにも対応
   */
  $(document).on('click', 'a[href*="#"]', function(e) {
    const href = $(this).attr('href');
    
    // #のみの場合はスキップ
    if (href === '#') {
      return;
    }
    
    // URLを解析してパス部分とハッシュ部分を分離
    let linkPath = '';
    let hash = '';
    
    if (href.indexOf('#') !== -1) {
      const parts = href.split('#');
      linkPath = parts[0];
      hash = '#' + parts[1];
    } else {
      return; // ハッシュがない場合はスキップ
    }
    
    // 現在のページのパスを取得
    const currentPath = window.location.pathname;
    
    // リンク先が現在のページかどうかを判定
    let isSamePage = false;
    
    if (linkPath === '' || linkPath === '#') {
      // href="#xxx" の場合は同一ページ
      isSamePage = true;
    } else if (linkPath.startsWith('/')) {
      // 絶対パス: /sismil/index.html#news
      isSamePage = (linkPath === currentPath || linkPath + '/' === currentPath || linkPath === currentPath.replace(/\/$/, ''));
    } else if (linkPath.startsWith('http')) {
      // 完全URL: http://example.com/sismil/index.html#news
      const linkUrl = new URL(href, window.location.href);
      isSamePage = (linkUrl.pathname === currentPath || linkUrl.pathname + '/' === currentPath || linkUrl.pathname === currentPath.replace(/\/$/, ''));
    } else {
      // 相対パス: index.html#news, ./index.html#news
      const linkUrl = new URL(href, window.location.href);
      isSamePage = (linkUrl.pathname === currentPath);
    }
    
    // 同一ページ内のアンカーリンクの場合
    if (isSamePage && hash) {
      const targetId = hash.substring(1); // #を除去
      
      // ターゲット要素が存在する場合のみスムーススクロール
      if ($('#' + targetId).length > 0) {
        e.preventDefault();
        smoothScrollTo(targetId, 600, false); // 同一ページ内クリックなので withCorrection=false
        
        // URLのハッシュを更新（ブラウザの履歴に追加）
        if (history.pushState) {
          history.pushState(null, null, hash);
        } else {
          // 古いブラウザ用のフォールバック
          window.location.hash = hash;
        }
      }
    }
    // 別ページへのアンカーリンクの場合は通常の遷移を行う（e.preventDefault()しない）
  });

  /**
   * 別ページから遷移してきた場合のアンカーリンク処理
   * ページ読み込み時にURLのハッシュをチェックしてスクロール
   */
  function handlePageLoadHash() {
    const hash = window.location.hash;
    
    if (hash && hash.length > 1) {
      const targetId = hash.substring(1); // #を除去
      
      // デフォルトのジャンプを防ぐ
      if (history.scrollRestoration) {
        history.scrollRestoration = 'manual';
      }
      
      // 一旦トップにスクロール
      window.scrollTo(0, 0);
      $('html, body').scrollTop(0);
      
      /**
       * 画像の読み込み完了を待ってからスクロール
       */
      function waitForImagesAndScroll() {
        const $target = $('#' + targetId);
        
        if ($target.length === 0) {
          console.warn('Target element not found:', targetId);
          return;
        }
        
        // ページ内のすべての画像
        const images = document.images;
        const totalImages = images.length;
        let loadedImages = 0;
        let maxWaitTime = 500; // 最大待機時間: 500ms
        let startTime = Date.now();
        
      /**
       * スクロール実行（画像読み込みの状態に関わらず）
       */
      function executeScroll() {
        // 位置補正ありでスクロール
        smoothScrollTo(targetId, 600, true);
      }        // 画像がない場合はすぐにスクロール
        if (totalImages === 0) {
          setTimeout(executeScroll, 600);
          return;
        }
        
        /**
         * 画像読み込みチェック
         */
        function checkImagesLoaded() {
          loadedImages = 0;
          
          for (let i = 0; i < images.length; i++) {
            if (images[i].complete && images[i].naturalHeight !== 0) {
              loadedImages++;
            }
          }
          
          const elapsed = Date.now() - startTime;
          
          // すべての画像が読み込まれたか、最大待機時間を超えた場合
          if (loadedImages === totalImages || elapsed >= maxWaitTime) {
            executeScroll();
          } else {
            // 100ms後に再チェック
            setTimeout(checkImagesLoaded, 100);
          }
        }
        
        // 画像読み込みチェック開始
        checkImagesLoaded();
      }
      
      // DOMとスタイルの準備ができてから実行
      if (document.readyState === 'complete') {
        // すでに読み込み完了している場合
        setTimeout(waitForImagesAndScroll, 100);
      } else {
        // 読み込み完了を待つ
        $(window).on('load', function() {
          setTimeout(waitForImagesAndScroll, 100);
        });
      }
    }
  }

  // ページ読み込み時のハッシュ処理
  handlePageLoadHash();

  // ブラウザの戻る/進むボタンでのハッシュ変更に対応
  $(window).on('hashchange', function() {
    const hash = window.location.hash;
    if (hash && hash.length > 1) {
      const targetId = hash.substring(1);
      smoothScrollTo(targetId, 600, true); // 位置補正あり
    }
  });
});

// ---------------------------
// 元の main.js の初期化ログ
// ---------------------------
console.log('Main.js initialized');
